import { get, post } from '../../utils/http'

// export const getChoices = () => get(`/subjects/get_choice_list`)
export const getChoices = () => get(`/sjsy/api/subject/choice/gets`)
// export const getSubjects = province => get(`/subjects/get_subjects_list?provinceId=${province}`)
export const getSubjects = province => get(`/sjsy/api/subject/choice/list?province_id=${province}`)
// export const postSubjects = query => post(`/subjects/setup_choice?${query}`)
export const postSubjects = query => post(`/sjsy/api/subject/choice/save`,query);
// export const getDetail = () => get(`/accounts/get_detail/`)
export const getDetail = () => get(`/sjsy/api/user/detail`);
export const getRecommendSubject = () => get(`/sjsy/api/subject/choice/rec/get`);



// WEBPACK FOOTER //
// ./src/api/subjectChoice/index.js